import { useSafeContext } from '@aspendental/shared-utils/react';
import { createContext, useMemo } from 'react';
import { TCity, TState, TOfficeInfo, TReviews } from '@shared-components/types';
const OfficeLocationContext = createContext({
  states: [] as Array<TState>,
  cities: [] as Array<TCity>,
  officeInfo: {} as TOfficeInfo,
  reviews: {} as TReviews
});
OfficeLocationContext.displayName = 'OfficeLocationContext';
interface IOfficeLocationContextProvider {
  states?: Array<TState>;
  cities?: Array<TCity>;
  officeInfo?: TOfficeInfo;
  reviews?: TReviews;
  children: React.ReactNode;
}
export function OfficeLocationContextProvider({
  children,
  states = [],
  cities = [],
  officeInfo = {} as TOfficeInfo,
  reviews = {} as TReviews
}: Readonly<IOfficeLocationContextProvider>) {
  const officeLocationContextData = useMemo(() => ({
    states,
    cities,
    officeInfo,
    reviews
  }), [states, cities, officeInfo, reviews]);
  return <OfficeLocationContext.Provider value={officeLocationContextData} data-sentry-element="OfficeLocationContext.Provider" data-sentry-component="OfficeLocationContextProvider" data-sentry-source-file="OfficeLocationsContextProvider.ctx.tsx">{children}</OfficeLocationContext.Provider>;
}
export function useOfficeLocationContext() {
  return useSafeContext(OfficeLocationContext);
}